import React, { useCallback } from 'react';

const FormTextAreaField = ({
    touched,
    name,
    values,
    placeholder,
    className,
    maxLength,
    handleChange,
}) => {
    const handleChangeValue = useCallback(
        e => {
            touched[name] = false;
            return handleChange(e);
        },
        [touched, handleChange, name]
    );

    return (
        <textarea
            onChange={handleChangeValue}
            name={name}
            value={values[name]}
            placeholder={placeholder}
            className={className}
            maxLength={maxLength}
        />
    );
};

export default FormTextAreaField;
